/**
 * dir-w | backOffice
 * Page loading, nothing to do here just to show the loading spinner
 *
 * Last update : January 10, 2024 | @rizkiprasetya
 */

import { Component } from '@angular/core';
import { Configuration } from '../../config/configuration';

@Component({
    selector: 'app-page-loading',
    templateUrl: './page-loading.component.html',
    styleUrl: './page-loading.component.css',
    standalone: false
})
export class PageLoadingComponent {
  protected profilePath: string = `/assets/profile/${Configuration.Profile}/images/background.png`;
}
